import React from "react";
import { TokenProvider, useToken } from "lib/contexts/TokenProvider";
import Skeleton from "components/common/loaders/Skeleton";
import { useSearchParams } from "react-router-dom";

const AppWrapperContent = ({ children }: { children: React.ReactNode }) => {
  const {
    state: { tokenId, cartPayload },
  } = useToken();

  const [searchParams] = useSearchParams();
  const pageName = searchParams.get("page")?.toLowerCase();

  // Show skeleton when:
  // 1. No token is present AND
  // 2. Either no page name is specified OR the page requires a token
  const isCheckoutPage = !pageName || pageName === "mock-checkout";
  const isCartPage = pageName === "cart";

  // Display when cart loading data variables are not present
  const displayCartLoader = !cartPayload && !tokenId && isCartPage;

  if (!tokenId && isCheckoutPage) {
    return <Skeleton />;
  }

  if (displayCartLoader) {
    return <Skeleton />;
  }

  return <>{children}</>;
};

const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <TokenProvider>
      <AppWrapperContent>{children}</AppWrapperContent>
    </TokenProvider>
  );
};

export default AppWrapper;